<template>
  <div>
    <v-dialog
      ref="dialog"
      v-model="modal"
      :return-value.sync="localValue"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          readonly
          v-bind="attrs"
          v-on="on"
          :color="color"
          :label="labelFilter"
          :append-icon="postIcon"
          :prepend-icon="preIcon"
          :clearable="clearable"
          v-model="localValue"
          :class="classes['date']"
          :style="localStyle['date']"
        ></v-text-field>
      </template>
      <v-date-picker :color="color" v-model="localValue" scrollable>
        <v-spacer></v-spacer>
        <v-btn text :color="color" @click="modal = false"> Cancel </v-btn>
        <v-btn text :color="color" @click="$refs.dialog.save(localValue)">
          OK
        </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import emittable from "../../../mixins/emittable";

import {
  VDialog,
  VTextField,
  VDatePicker,
  VSpacer,
  VBtn
} from 'vuetify/lib'

export default {
  mixins: [emittable],
  components: {
    VDialog,
    VTextField,
    VDatePicker,
    VSpacer,
    VBtn
  },
  name: "FilterDate",
  props: {
    labelFilter: {
      type: String,
      default: "Select a date",
    },
    value: {
      type: String,
      default: new Date().toISOString().substr(0, 10),
    },
    color: {
      type: String,
      default: "primary",
    },
    filterValue: {
      type: String,
      default: undefined,
    },
    color: {
      type: String,
      default: "primary",
    },
    postIcon: {
      type: String,
      default: undefined,
    },
    preIcon: {
      type: String,
      default: "mdi-calendar",
    },
    range: {
      type: Boolean,
      default: undefined,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    styles: {
      type: Object,
      default: function () {
        return {
          date: {},
        };
      },
    },
    classes: {
      type: Object,
      default: function () {
        return {
          date: {},
        };
      },
    },
  },
  data: function () {
    let ls = { ...this.styles };

    if (!ls["date"]) ls["date"] = {};

    if (!ls["date"]["width"]) ls["date"]["width"] = "130px";

    return {
      localValue: this.value,
      localStyle: ls,
      modal: false,
    };
  },
  watch: {
    localValue(val) {
      this.emit("input", val);
      this.emit("change", val);
    },
    value(val) {
      if (val !== this.localValue) this.localValue = val;
    },
  },
};
</script>

<style>
</style>